import { Table as AntTable } from "antd";
import { TableProps } from "antd/es/table/InternalTable";
export const Table = ({
  ...rest
}: TableProps<any>) => {
  return <>
            <AntTable tableLayout="fixed" scroll={{
      x: '100%'
    }} pagination={false} {...rest} data-sentry-element="AntTable" data-sentry-source-file="index.tsx" />
        </>;
};
export const sortOrderTransform = (value: string, useFrontValue = false) => {
  if (useFrontValue) {
    switch (value) {
      case 'asc':
        return 'ascend';
      case 'desc':
        return 'descend';
      default:
        return null;
    }
  } else {
    switch (value) {
      case 'ascend':
        return 'asc';
      case 'descend':
        return 'desc';
      default:
        return null;
    }
  }
};